import jQuery from "jquery";
/**
 * Preload a single image from given url
 * @param src The URL of the img to preload
 * @returns A promise containing the onload event of the image
 */
export function preloadImage(src) {
    return new Promise((resolve) => {
        let img = new Image();
        img.onload = resolve;
        img.src = src;
    });
}
/**
 * Preloads all images and returns when all have settled
 * @param srcs URLs to images to preload
 * @returns A list of promise results containing the onload event of the image or an  error
 */
export function preloadImages(srcs) {
    let preloadPromises = [];
    for (let src of srcs) {
        preloadPromises.push(preloadImage(src));
    }
    return Promise.allSettled(preloadPromises);
}
export function getBrandIconPath(brandName) {
    if (!brandName) {
        return "";
    }
    let brandId = brandName.split(" ")[0];
    return "assets/demo/brand_icon_" + brandId.toLowerCase() + ".png";
}
export function RemoveImageOnErrorCallback(event) {
    jQuery(event.target).remove();
}
